var MDB = window.MDB || {};
MDB.Security = MDB.Security || {};

(function($){
    var validatedPermissionCache = {};

    $.extend(MDB.Security, {
        Permissions: {
            //WorkLog = SprintFiltersManagement
            WorkLog: '5A199901-4381-4EFC-8EF1-7ABBEB402161',
            SettingsDivisionMiscellaneous: 'A1B9B2E3-4E3B-49FD-83A6-03EF3D19BF44',
            
            WidgetClickExecuteStoredProcedure: '7f914e33-76d0-4351-b0fe-276b2d31e5f1',
            DmVisualizer: '2E20167A-AE9C-4C16-BF03-C15145C24DED',

            //Start SprintPlanning
            SprintPlanning: '5C1BEA33-67EE-40B1-BF58-FDBA10E7F7B6',
            SprintPlanningTimeTracking: '77d47ceb-b8ed-47df-9549-2f1079cb5f2b',
            SprintPlanningComments: '93ec6dbf-99e1-4bc8-b9de-228f78b4bcac',
            //End SprintPlanning
            
            //Start Journey Composer
            JourneyBuilder: 'c631638b-067a-42ed-b9a1-9e273aee0b45',
            //End Journey Composer
            
            //Start EMV
            MediaLibrary: '2de72a19-dadb-47f9-ae71-3e6c8225a859',
            EmvPrimaryTemplateBuilder: 'de07fdd1-fa0d-4b54-b5bb-3dd55de5ea15',
            EmvTemplateFiller: '880d398b-df30-43eb-b306-53a62732eea4',
            EmvCustomCss: '0e9614b2-5b9f-4cbf-9a61-cf9624b8cd3f',
            //End EMV
            
            //Start DPN
            DpnOfferSettingsViewInvalid: '0547E638-7930-4D57-9812-CB9C5C60363C',
            DpnOffersSettingsDelete: 'A5138E3D-E74A-4E9E-92ED-3C373F73B07D',
            //End DPN

            //Start Zeiss
            ZeissCompanies: 'BBB366AB-EA64-4D8F-9FD5-C5C80AE0F2C7'
            //End Zeiss
        },
        PermissionGrantTypes: {
            Read: 1,
            Write: 2,
            Delete: 4,
            SeeInMenu: 8
        },

        //TODO: Cache current user permissions on page load?
        /**
         * @param permission Permission to validate
         *
         * @param grantType An Array, or the sum of the PermissionGrantTypes to validate
         * @default Read + Write + Delete
         *
         * @return {boolean|*|Promise|*}
         */
        validatePermission: function (permission, grantType) {
            //No use in validating when we aren't logged in
            if(!MDB.CurrentUser){
                console.warn('No user logged in - unable to validate permission: ' + permission);
                return $.Deferred().reject('No user logged in').promise();
                // return false;
            }

            //Base our cache key on the given permissionId
            var cacheKey = permission;

            if(grantType){
                if(_.isArray(grantType)){
                    //MVC requires a single number
                    grantType = grantType.reduce(function(sum, cur){
                        return sum + cur;
                    }, 0);
                }

                //Include grantType in our cache key
                cacheKey = cacheKey + '|' + grantType;
            }

            if(validatedPermissionCache[cacheKey]){
                return validatedPermissionCache[cacheKey]
            }

            //We want to do the least possible processing prior to cachingS 
            var def = $.Deferred();

            //Set our cacheKey asap
            var prom = validatedPermissionCache[cacheKey] = def.promise();

            //Call the API and resolve our promise as usual
            MDB.callApi({
                url: 'Users/ValidateRight',
                data: {
                    rightId: permission,
                    grantType: grantType
                }
            }).done(function(){
                def.resolve.apply(def, arguments);
            }).error(function(){
                def.reject.apply(def, arguments);
            });

            return prom;
        }
    });
}(jQuery));